import 'normalize.css/normalize.css';
import '@/components/pages/App/globals.scss';

import SentryBox from '@/mechanisms/SentryBox';

SentryBox.initialize();

export {default} from '@/components/pages/App';
